<template>
  <section class="pt-seo" aria-hidden="true">
    <pitch-type-detail :pitchtype="pitchtype" :show-pitchtype-details="true">
      <template #extras>
        <extras :extras="pitchtype.extras" class="extras-table">
          <template #extra="{ extra }">
            <extra-non-dated :extra="extra" />
          </template>
        </extras>
      </template>
    </pitch-type-detail>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { PitchTypeWithChargeType } from '../../types'

@Component
class PitchTypeSeoCard extends Vue {
  @Prop()
  pitchtype: PitchTypeWithChargeType

  get allowedSubcategories() {
    return this.pitchtype.allowedSubcategories.map((c) => c.name)
  }
}

export default toNative(PitchTypeSeoCard)
</script>
<style scoped>
.pt-seo {
  display: none;
}
</style>
